'kiwi public';

import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _ from 'lodash';
import * as Misc from '@/helpers/Misc';
import Logger from '@/libs/Logger';
import BouncerProvider from '@/libs/BouncerProvider';
import Captcha from '@/components/Captcha';
import StartupLayout from './CommonLayout';
var log = Logger.namespace('Welcome.vue');
export default {
  components: {
    Captcha: Captcha,
    StartupLayout: StartupLayout
  },
  data: function data() {
    return {
      connectErrors: [],
      network: null,
      channel: '',
      nick: '',
      password: '',
      oauthLoading: false,
      oauthError: '',
      showChannel: true,
      showPass: true,
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false
    };
  },
  computed: {
    isIframe: function isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions: function startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText: function footerText() {
      var footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    oauthConfig: function oauthConfig() {
      return this.$state.settings.oauth || null;
    },
    termsContent: function termsContent() {
      var terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    isNickValid: function isNickValid() {
      var nickPatternStr = this.$state.setting('startupOptions.nick_format');
      var nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        var pattern = '';
        var flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          var pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart: function readyToStart() {
      var ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }

      // Make sure the channel name starts with a common channel prefix
      if (!this.connectWithoutChannel) {
        var bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(function (bufferObj) {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }

      // If toggling the password is is disabled, assume it is required
      if (!this.toggablePass && !this.password) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  watch: {
    show_password_box: function show_password_box(newVal) {
      if (newVal === false) {
        // clear the password when show password is unchecked
        this.password = '';
      }
    }
  },
  created: function created() {
    var _context;
    log.error('Welcome created', {
      search: window.location.search
    });
    var options = this.startupOptions;
    var connectOptions = this.connectOptions();

    // Take some settings from a previous network if available
    var previousNet = null;
    if (_trimInstanceProperty(_context = connectOptions.hostname).call(_context)) {
      var _context2;
      previousNet = this.$state.getNetworkFromAddress(_trimInstanceProperty(_context2 = connectOptions.hostname).call(_context2));
    }
    if (previousNet && previousNet.connection.nick) {
      this.nick = previousNet.connection.nick;
    } else if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else {
      this.nick = options.nick;
    }
    this.nick = this.processNickRandomNumber(this.nick || '');
    if (options.password) {
      this.password = options.password;
    } else if (previousNet && previousNet.password) {
      this.password = previousNet.password;
      this.show_password_box = true;
    } else {
      this.password = '';
    }
    this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
    this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
    this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
    this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
    this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
    this.connectWithoutChannel = !!options.allowNoChannel;
    if (options.bouncer) {
      this.toggablePass = false;
      this.showPass = true;
      this.showChannel = false;
      this.connectWithoutChannel = true;
      var bouncer = new BouncerProvider(this.$state);
      bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
    }
    if (options.autoConnect && this.readyToStart) {
      this.startUp();
    }

    // OAuth bootstrap
    this.restoreOAuth();
    this.handleOAuthCallback();
  },
  methods: {
    startOAuth: function startOAuth() {
      var _context3;
      if (!this.oauthConfig) {
        return;
      }
      var state = _sliceInstanceProperty(_context3 = Math.random().toString(16)).call(_context3, 2, 10) + Date.now();
      try {
        window.sessionStorage.setItem('kiwi_oauth_state', state);
      } catch (err) {
        // ignore
      }
      var url = new _URL(this.oauthConfig.login_url);
      url.searchParams.set('state', state);
      window.location = url.toString();
    },
    restoreOAuth: function restoreOAuth() {
      try {
        var raw = window.localStorage.getItem('kiwi_oauth_login');
        if (!raw) {
          return;
        }
        var data = JSON.parse(raw);
        if (data && data.username && data.access_token && (!data.expires || Date.now() < data.expires)) {
          this.nick = data.username;
          this.password = '';
          this.showPass = false;
        }
      } catch (err) {
        // ignore
      }
    },
    handleOAuthCallback: function handleOAuthCallback() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, code, state, storedState, tokenResp, profile, username, expires, storeObj, _t;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this.oauthConfig) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              params = new _URLSearchParams(window.location.search);
              code = params.get('code');
              state = params.get('state');
              if (code) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              storedState = null;
              try {
                storedState = window.sessionStorage.getItem('kiwi_oauth_state');
              } catch (err) {
                // ignore storage errors (eg. disabled)
              }
              log.error('OAuth callback received', {
                code: !!code,
                state: state,
                storedState: storedState || '(none)'
              });
              if (!(storedState && storedState !== state)) {
                _context4.next = 3;
                break;
              }
              _this.oauthError = 'OAuth state mismatch';
              log.warn('OAuth state mismatch', {
                state: state,
                storedState: storedState
              });
              return _context4.abrupt("return");
            case 3:
              try {
                window.sessionStorage.removeItem('kiwi_oauth_state');
              } catch (err) {
                // ignore
              }
              _this.oauthLoading = true;
              _context4.prev = 4;
              _context4.next = 5;
              return _this.exchangeCode(code);
            case 5:
              tokenResp = _context4.sent;
              if (!(!tokenResp || !tokenResp.access_token)) {
                _context4.next = 6;
                break;
              }
              throw new Error('No access token');
            case 6:
              _context4.next = 7;
              return _this.fetchProfile(tokenResp.access_token, tokenResp.id_token);
            case 7:
              profile = _context4.sent;
              username = _this.pickUsername(profile);
              if (username) {
                _context4.next = 8;
                break;
              }
              throw new Error('No username in profile');
            case 8:
              expires = tokenResp.expires_in ? Date.now() + tokenResp.expires_in * 1000 : 0;
              storeObj = {
                access_token: tokenResp.access_token,
                id_token: tokenResp.id_token || '',
                username: username,
                expires: expires
              };
              window.localStorage.setItem('kiwi_oauth_login', _JSON$stringify(storeObj));
              _this.nick = username;
              _this.password = '';
              _this.showPass = false;
              // Drop query params
              window.history.replaceState({}, document.title, window.location.pathname);
              _context4.next = 10;
              break;
            case 9:
              _context4.prev = 9;
              _t = _context4["catch"](4);
              _this.oauthError = _t.message || 'OAuth failed';
              log.error('OAuth exchange failed', {
                err: _t && _t.message ? _t.message : String(_t)
              });
            case 10:
              _context4.prev = 10;
              _this.oauthLoading = false;
              return _context4.finish(10);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee, null, [[4, 9, 10, 11]]);
      }))();
    },
    exchangeCode: function exchangeCode(code) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var body, resp;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              body = new _URLSearchParams();
              body.set('grant_type', 'authorization_code');
              body.set('code', code);
              body.set('redirect_uri', _this2.oauthConfig.redirect_uri);
              body.set('client_id', _this2.oauthConfig.client_id || '');
              if (_this2.oauthConfig.client_secret) {
                body.set('client_secret', _this2.oauthConfig.client_secret);
              }
              _context5.next = 1;
              return fetch(_this2.oauthConfig.token_url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: body.toString()
              });
            case 1:
              resp = _context5.sent;
              if (resp.ok) {
                _context5.next = 2;
                break;
              }
              throw new Error('Token exchange failed');
            case 2:
              _context5.next = 3;
              return resp.json();
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee2);
      }))();
    },
    fetchProfile: function fetchProfile(accessToken, idToken) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var parts, payload, resp, json, _t2, _t3;
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!idToken) {
                _context6.next = 4;
                break;
              }
              _context6.prev = 1;
              parts = idToken.split('.');
              if (!(parts.length === 3)) {
                _context6.next = 2;
                break;
              }
              payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
              return _context6.abrupt("return", payload || {});
            case 2:
              _context6.next = 4;
              break;
            case 3:
              _context6.prev = 3;
              _t2 = _context6["catch"](1);
            case 4:
              if (!_this3.oauthConfig.me_url) {
                _context6.next = 12;
                break;
              }
              _context6.prev = 5;
              _context6.next = 6;
              return fetch(_this3.oauthConfig.me_url, {
                headers: {
                  Authorization: "Bearer ".concat(accessToken)
                }
              });
            case 6:
              resp = _context6.sent;
              if (!resp.ok) {
                _context6.next = 9;
                break;
              }
              _context6.next = 7;
              return resp.json();
            case 7:
              json = _context6.sent;
              if (!json) {
                _context6.next = 8;
                break;
              }
              return _context6.abrupt("return", json);
            case 8:
              _context6.next = 10;
              break;
            case 9:
              log.error('Profile fetch failed', {
                status: resp.status,
                statusText: resp.statusText
              });
            case 10:
              _context6.next = 12;
              break;
            case 11:
              _context6.prev = 11;
              _t3 = _context6["catch"](5);
              log.error('Profile fetch failed', {
                err: _t3 && _t3.message ? _t3.message : String(_t3)
              });
            case 12:
              return _context6.abrupt("return", {});
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee3, null, [[1, 3], [5, 11]]);
      }))();
    },
    pickUsername: function pickUsername(profile) {
      var keys = ['preferred_username', 'username', 'user_login', 'user_nicename', 'name'];
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var k = _keys[_i];
        if (profile[k] && typeof profile[k] === 'string') {
          return this.sanitize(profile[k]);
        }
      }
      if (profile.email && typeof profile.email === 'string') {
        var at = profile.email.indexOf('@');
        if (at > 0) {
          return this.sanitize(profile.email.substr(0, at));
        }
      }
      return '';
    },
    sanitize: function sanitize(str) {
      var _context7;
      var out = _trimInstanceProperty(_context7 = str || '').call(_context7).replace(/[^0-9a-zA-Z_-]/g, '');
      if (!out) {
        return '';
      }
      if (/^[0-9]/.test(out)) {
        out = 'u_' + out;
      }
      return out;
    },
    onAltClose: function onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    startUp: function startUp() {
      var _this4 = this;
      this.connectErrors = [];
      var options = _Object$assign({}, this.$state.settings.startupOptions);
      var connectOptions = this.connectOptions();
      var netAddress = _trimInstanceProperty(_).call(_, connectOptions.hostname);

      // Check if we have this network already
      var net = this.network || this.$state.getNetworkFromAddress(netAddress);
      var password = this.password;

      // If the network doesn't already exist, add a new one
      net = net || this.$state.addNetwork('Network', this.nick, {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: _trimInstanceProperty(_).call(_, options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: options.gecos,
        username: options.username
      });

      // Clear the server buffer in case it already existed and contains messages relating to
      // the previous connection, such as errors. They are now redundant since this is a
      // new connection.
      net.serverBuffer().clearMessages();

      // If we retreived an existing network, update the nick+password with what
      // the user has just put in place
      net.connection.nick = this.nick;
      if (options.bouncer) {
        var _context8;
        // Bouncer mode uses server PASS
        net.connection.password = _concatInstanceProperty(_context8 = "".concat(this.nick, ":")).call(_context8, password);
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      if (_trimInstanceProperty(_).call(_, options.encoding || '')) {
        net.connection.encoding = _trimInstanceProperty(_).call(_, options.encoding);
      }
      this.network = net;

      // Only switch to the first channel we join if multiple are being joined
      var hasSwitchedActiveBuffer = false;
      var bufferObjs = Misc.extractBuffers(this.channel);
      bufferObjs.forEach(function (bufferObj) {
        var newBuffer = _this4.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          _this4.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });

      // switch to server buffer if no channels are joined
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }
      net.ircClient.connect();
      var _onRegistered = function onRegistered() {
        if (_this4.$refs.layout) {
          _this4.$refs.layout.close();
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var _onClosed = function onClosed() {
        var _context9;
        var lastError = _this4.network.last_error;
        if (lastError && !_includesInstanceProperty(_context9 = _this4.connectErrors).call(_context9, lastError)) {
          _this4.connectErrors.push(lastError);
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var onError = function onError(event) {
        var _context0;
        if (!event.reason || _includesInstanceProperty(_context0 = _this4.connectErrors).call(_context0, event.reason)) {
          return;
        }
        _this4.connectErrors.push(event.reason);
      };
      net.ircClient.once('registered', _onRegistered);
      net.ircClient.once('close', _onClosed);
      net.ircClient.on('irc error', onError);
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      // Replace ? with a random number
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return _trimInstanceProperty(_).call(_, tmp);
    },
    handleCaptcha: function handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions: function connectOptions() {
      var options = _Object$assign({}, this.$state.settings.startupOptions);
      var connectOptions = Misc.connectionInfoFromConfig(options);

      // If a server isn't specified in the config, set some defaults
      // The webircgateway will have a default network set and will connect
      // there instead. This just removes the requirement of specifying the same
      // irc network address in both the server-side and client side configs
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
